import { applySnapshot, IStateTreeNode } from "mobx-state-tree";

export const withReset = <T extends IStateTreeNode>(mstInstance: T) => ({
  reset: () => {
    applySnapshot(mstInstance, {});
  },
});
